import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { RoleTypeEnum, UserDto } from '../../commonTypes/user.types';
import { restoreAll } from '../restoreAll';

export interface AuthState {
    value: UserDto;
    initialized: boolean;
}

export const userInitialState: AuthState = {
    value: {
        userSub: '',
        email: '',
        organizationId: '',
        profile: {
            userSub: '',
            familyName: '',
            givenName: '',
            children: [],
            updatedAt: '',
        },
        role: {
            name: RoleTypeEnum.BASIC,
        },
        configuration: {
            userSub: '',
        },
        branchId: null,
    },
    initialized: false,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState: userInitialState,
    extraReducers: builder => builder.addCase(restoreAll, () => userInitialState),
    reducers: {
        addAuth: (state, action) => {
            state.value = action.payload;
            state.initialized = true;
        },
        updateProfile: (state, action) => {
            state.value.profile = action.payload;
        },
        updateProfileImage: (state, action) => {
            state.value.profile.imageUrl = action.payload;
        },
    },
});

export const { addAuth, updateProfile, updateProfileImage } = authSlice.actions;

export const selectAuth = (state: RootState) => state.auth.value;

export const selectConfiguration = (state: RootState) => state.auth.value.configuration;

export const selectOrganizationId = (state: RootState) => state.auth.value.organizationId;

export const selectUserRole = (state: RootState) => state.auth.value.role;

export const selectUserSub = (state: RootState) => state.auth.value.userSub;

export const selectEmail = (state: RootState) => state.auth.value.email;

export const selectJoinedAt = (state: RootState) => state.auth.value.joinedAt;

export const selectProfileImage = (state: RootState) => state.auth.value.profile.imageUrl;

export const selectAuthInitialized = (state: RootState) => state.auth.initialized;

export default authSlice.reducer;
